import { render, staticRenderFns } from "./RelationData.vue?vue&type=template&id=3a575024&scoped=true&"
import script from "./RelationData.vue?vue&type=script&lang=ts&"
export * from "./RelationData.vue?vue&type=script&lang=ts&"
import style0 from "./RelationData.vue?vue&type=style&index=0&id=3a575024&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a575024",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/intern/customer-portal/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import GCardIcon from 'shared/global/components/CardIcon.vue'
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
installComponents(component, {GCardIcon,VCard,VCardTitle,VDivider,VList,VListTile,VListTileContent})
